export default {
  setLoginInfo: 'LOGIN_INFO',
  userInfo: 'USER_INFO',
  logout: 'LOGOUT',
  loginModal: 'LOGIN_MODAL_VISIBLE',
  forgetModal: 'FORGET_MODAL_VISIBLE',
  carousel_list: 'carousel_list',
  brand_info: 'brand_info',
  msg_list: 'msg_list'
}
